import { render, staticRenderFns } from "./CiProgressBar.vue?vue&type=template&id=2ceb0824&scoped=true"
import script from "./CiProgressBar.vue?vue&type=script&lang=js"
export * from "./CiProgressBar.vue?vue&type=script&lang=js"
import style0 from "./CiProgressBar.vue?vue&type=style&index=0&id=2ceb0824&prod&lang=scss"
import style1 from "./CiProgressBar.vue?vue&type=style&index=1&id=2ceb0824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb0824",
  null
  
)

export default component.exports